import CustomBadge from '../CustomBadge';
import { FormVersionStatus, FORM_VERSION_STATUS_LABEL } from '../../views/SystemSettings/Forms/FormVersionStatus';

const COLOR: Record<FormVersionStatus, string> = {
  [FormVersionStatus.Draft]: '#6b7684',
  [FormVersionStatus.Scheduled]: '#a3690b',
  [FormVersionStatus.Active]: '#1f7a52',
  [FormVersionStatus.Superseded]: '#6b6f9c',
};

type FormVersionStatusPillProps = {
  rowObject?: { status?: FormVersionStatus | null; version: number };
};

// Draft/Scheduled/Active state pill for the Forms list — the same three statuses (plus
// Superseded, which never shows up here since it's never a form's "most notable" status).
function FormVersionStatusPill({ rowObject }: FormVersionStatusPillProps) {
  const status = rowObject?.status;
  const version = rowObject?.version ?? 1;

  if (status == null) return version;

  return (
    <CustomBadge color={COLOR[status]}>
      {version}
      <em className="ml-1">
        <small>{FORM_VERSION_STATUS_LABEL[status]}</small>
      </em>
    </CustomBadge>
  );
}

export default FormVersionStatusPill;
